import React from 'react';
import { Field } from 'react-final-form';
import { FormattedMessage } from 'react-intl';

import FormItem from 'common/Form/components/FormItem';
import { required as isRequired, validateEmail } from 'utils/validation';

import { InputText } from '../UI';

/**
 * @typedef {{
 *  name?: string,
 *  required?: boolean,
 * } & HTMLInputElement} EmailProps
 */

/** @type {React.FC<EmailProps>} */
const EmailInput = ({ required, name = 'email', ...rest }) => {
  const handleValidation = value => {
    let error;

    if (required) {
      error = isRequired(value);
    }

    if (!error) {
      error = validateEmail(value);
    }

    return error;
  };

  return (
    <Field name={name} subscription={{ value: true, error: true, touched: true }} validate={handleValidation}>
      {({ input, meta }) => (
        <FormItem
          title={<FormattedMessage id="web.email" defaultMessage="Email address" />}
          {...meta}
          data-cy="input-email"
          required={required}
        >
          <InputText {...input} {...rest} />
        </FormItem>
      )}
    </Field>
  );
};

export default EmailInput;
